import { render } from "./Disclaimers.vue?vue&type=template&id=d7d32784&scoped=true"
const script = {}

import "./Disclaimers.vue?vue&type=style&index=0&id=d7d32784&scoped=true&lang=css"

import exportComponent from "I:\\JavaWork\\Recruit\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7d32784"]])

export default __exports__